/** Umsatzsteuer für die UVP brutto. */
export const MWST_PROZENT = 19;
/**
 * Cent plus Aufschlag in % (höchstens zwei Nachkommastellen), kaufmännisch auf
 * ganze Cent. Ganzzahlig gerechnet: Ein halber Cent ist exakt darstellbar.
 */
export function mitAufschlag(cent, prozent) {
    return Math.round((cent * (10000 + Math.round(prozent * 100))) / 10000);
}
/**
 * Die Preisebenen einer Geldzeile: EK privat = EK + Mindermenge; ERP-EK und UVP
 * rechnen auf den EK privat. Ein UVP von Hand gilt unabhängig von EK und Aufschlag.
 */
export function atelierPreisebenen(ekCent, kopf, uvpVonHandCent) {
    const ekPrivatCent = mitAufschlag(ekCent, kopf.mindermengeProzent);
    const uvpVonHand = uvpVonHandCent !== undefined;
    const uvpNettoCent = uvpVonHandCent ?? mitAufschlag(ekPrivatCent, kopf.uvpAufschlagProzent);
    return {
        ekPrivatCent,
        erpEkCent: mitAufschlag(ekPrivatCent, kopf.erpAufschlagProzent),
        uvpNettoCent,
        uvpBruttoCent: mitAufschlag(uvpNettoCent, MWST_PROZENT),
        uvpVonHand,
    };
}
//# sourceMappingURL=preisebenen.js.map